import DamagedView from './DamagedView';
import { withI18n } from 'react-i18next';

export default withI18n()(DamagedView);
